import {
  GoogleReCaptchaProvider,
  GoogleReCaptcha,
} from 'react-google-recaptcha-v3';
import React from 'react';

export const ReCaptcha = ({
  onVerifyCaptcha,
  reCaptchaKey,
  refreshReCaptcha,
}) => (
  <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey}>
    <GoogleReCaptcha
      className="google-recaptcha-custom-class"
      onVerify={onVerifyCaptcha}
      refreshReCaptcha={refreshReCaptcha}
    />
  </GoogleReCaptchaProvider>
);
